import { LoanProductCategory } from '@mediaingenuity/totallymoney.types'

import { categories, CategoryPath } from '@config/categories'

export const getCategoryIdForPath = (
    categoryPath: CategoryPath
): LoanProductCategory => {
    let categoryId: LoanProductCategory = 'PersonalLoan'

    for (const [key, value] of Object.entries(categories)) {
        if (categoryPath == value?.path) {
            categoryId = key as LoanProductCategory
            break
        }
    }

    return categoryId
}
